import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import appSlice from "./appSlice";
import authSlice from "./authSlice";
import { authApi } from "./authService";
import { appApi } from "./appService";

export const store = configureStore({
	reducer: {
		auth: authSlice.reducer,
		app: appSlice.reducer,
		[authApi.reducerPath]: authApi.reducer,
		[appApi.reducerPath]: appApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware()
		.concat(authApi.middleware)
		.concat(appApi.middleware),
	devTools: process.env.REACT_APP_ENV !== "production",
});
setupListeners(store.dispatch);
export default store;
